import styled from 'styled-components';

export const AppRouter = styled.div`
    padding: 83px 0 83px 72px;
    max-width: 947px;

    &.standalone {
        border-left: 40px solid #ffd00a;
    }
`;
